/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import SystemOptions from "../../../components/Administrations/ServerSettings/SystemOptions";
import { useGetSystemPropertiesQuery } from "../../../store/api/admin/adminApiSlice";

const ServerSettings: React.FC = () => {

  useGetSystemPropertiesQuery();

  return <SystemOptions />;
};

export default ServerSettings;